import React from 'react';
import { useTranslation } from 'react-i18next';
import { SmartphoneIcon, ShieldCheckIcon, ShoppingCartIcon, ZapIcon, CheckCircleIcon, BarChart3Icon, CloudIcon, DatabaseIcon } from 'lucide-react';
import { DiagnosticsModule } from './DiagnosticsModule';
export function AdvancedFeatures() {
  const {
    t
  } = useTranslation();
  return <section className="bg-white dark:bg-black py-20 relative overflow-hidden" data-id="element-3">
      <div className="absolute inset-0 bg-gradient-radial from-blue-500/5 dark:from-brand-green/5 to-transparent" data-id="element-4" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-5">
        <div className="text-center mb-16" data-id="element-6">
          <div className="inline-flex items-center px-4 py-1 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-full text-sm font-medium mb-4" data-id="element-7">
            <ZapIcon className="h-4 w-4 mr-2" data-id="element-8" />
            {t('advancedFeatures.badge')}
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-9">
            {t('advancedFeatures.title.prefix')}{' '}
            <span className="bg-gradient-to-r from-blue-600 to-blue-400 dark:from-brand-green dark:to-brand-green/60 bg-clip-text text-transparent" data-id="element-10">
              {t('advancedFeatures.title.highlight')}
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto" data-id="element-11">
            {t('advancedFeatures.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-12">
          {t('advancedFeatures.features', {
          returnObjects: true
        }).map((feature, index) => <div key={index} className="group relative bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-900/50 rounded-xl p-8 border border-gray-200 dark:border-gray-800 hover:border-blue-500 dark:hover:border-brand-green transition-colors" data-id="element-13">
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-blue-500/10 dark:from-brand-green/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" data-id="element-14" />
              <div className="relative" data-id="element-15">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-blue-100 dark:bg-brand-green/10 mb-6 group-hover:scale-110 transition-transform" data-id="element-16">
                  <div className="text-blue-600 dark:text-brand-green" data-id="element-17">
                    {index === 0 ? <SmartphoneIcon className="h-8 w-8" data-id="element-18" /> : index === 1 ? <ShieldCheckIcon className="h-8 w-8" data-id="element-19" /> : <ShoppingCartIcon className="h-8 w-8" data-id="element-20" />}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3" data-id="element-21">
                  {feature.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-22">
                  {feature.description}
                </p>
                <div className="space-y-3" data-id="element-23">
                  {feature.features.map((item, itemIndex) => <div key={itemIndex} className="flex items-center text-gray-700 dark:text-gray-300" data-id="element-24">
                      <CheckCircleIcon className="h-5 w-5 text-blue-500 dark:text-brand-green mr-2 flex-shrink-0" data-id="element-25" />
                      <span data-id="element-26">{item}</span>
                    </div>)}
                </div>
              </div>
            </div>)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-12" data-id="element-27">
          {t('advancedFeatures.stats', {
          returnObjects: true
        }).map((stat, index) => <div key={index} className="bg-gray-50 dark:bg-gray-900 rounded-lg p-6 border border-gray-200 dark:border-gray-800" data-id="element-28">
              <div className="flex items-center mb-4" data-id="element-29">
                <div className="p-2 bg-blue-100 dark:bg-brand-green/10 rounded-lg text-blue-600 dark:text-brand-green" data-id="element-30">
                  {index === 0 ? <CloudIcon className="h-6 w-6" data-id="element-31" /> : index === 1 ? <DatabaseIcon className="h-6 w-6" data-id="element-32" /> : index === 2 ? <BarChart3Icon className="h-6 w-6" data-id="element-33" /> : <ShoppingCartIcon className="h-6 w-6" data-id="element-34" />}
                </div>
              </div>
              <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-35">
                {stat.value}
              </div>
              <div className="text-sm text-gray-600 dark:text-gray-400" data-id="element-36">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}